import { createSelector } from '@reduxjs/toolkit';
import { reduxPostBoardNotesDataSelector } from './postBoardNotes';
const reduxPostBoardLinksReducer = (state) => state.reduxPostBoardLinks;
export const reduxPostBoardLinksDataSelector = createSelector(reduxPostBoardLinksReducer, (reducer) => reducer.data);
export const reduxPostBoardLinksWithNotesSelector = createSelector([reduxPostBoardLinksDataSelector, reduxPostBoardNotesDataSelector], (links, notes) => {
    const linksWithRelatedNotes = links.map((link) => {
        const relatedNotes = notes.filter((note) => note.link === link.id);
        return Object.assign(Object.assign({}, link), { notesInst: relatedNotes });
    });
    return linksWithRelatedNotes;
});
